import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosBox, SovosTypography } from "mosaic-react";

const PeriodsHeader = (props) => {
    const { i18n } = useGlobalValue();
    const { yearTypeName, yearName } = props;
    const periods = new Array(12).fill(0);

    return (
        <SovosBox sx={{ width: "100%" }}>
            <SovosBox
                sx={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    flex: "0 0 25.15rem",
                }}
            >
                <SovosBox
                    sx={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        paddingBottom: "10px",
                    }}
                >
                    {i18n`${yearTypeName} ${yearName}`}
                </SovosBox>
                <SovosBox
                    sx={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                    }}
                >
                    {periods.map((_, periodsIndex) => {
                        return (
                            <SovosBox
                                sx={{
                                    marginLeft: "1%",
                                    // marginRight: "3%",
                                    display: "flex",
                                    width: "1.2rem",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                                key={periodsIndex}
                            >
                                <SovosTypography variant={"h5"}>
                                    {periodsIndex > 12 ? `>${periodsIndex}` : periodsIndex + 1}
                                </SovosTypography>
                            </SovosBox>
                        );
                    })}
                </SovosBox>
            </SovosBox>
        </SovosBox>
    );
};

export default PeriodsHeader;
